import { Menu } from '@studiometa/ui';

/**
 * MobileBurgerMenu component
 */
export default class MobileBurgerMenu extends Menu {
  /**
   * Component Configuration
   */
  static config = {
    name: 'MobileBurgerMenu',
  };

  componentHeight = 0;

  /**
   * Set initial menu height
   */
  mounted() {
    this.setComponentHeight();
    super.mounted();
  }

  /**
   * Set component height
   */
  setComponentHeight() {
    this.$el.parentElement.style.height = '';
    this.componentHeight = this.$el.parentElement.clientHeight;
    this.$el.parentElement.style.height = `${this.componentHeight}px`;
  }

  /**
   * Set component height on resize
   */
  resized() {
    this.setComponentHeight();
  }

  /**
   * Reset menu height
   * @param {number} index
   * @param {Event} event
   */
  onMenuBtnClick(index, event) {
    this.$el.parentElement.style.height = `${this.componentHeight}px`;

    super.onMenuBtnClick(index, event);
  }

  /**
   * Set menu height based on children height
   * @param {number} index
   */
  onMenuListItemsOpen(index) {
    const targetMenu = this.$children.MenuList[index];
    this.$el.parentElement.style.height = `${targetMenu.$el.clientHeight}px`;

    super.onMenuListItemsOpen(index);
  }
}
